import React, { useState, useMemo, useEffect } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { z } from "zod";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import i1 from "../../../../Assets/images/authbg.png";
import {
  catchAsync,
  checkResponse,
  removeUnderScoreAndCapitalizeFirstLetter,
} from "../../../../utilities/utilities";
import {
  UPDATE_PROMOCODE,
  ADD_PROMOCODE,
  GET_PROMOCODE_BY_ID,
  ADD_PROMOTION,
  UPDATE_PROMOTION,
  GET_PROMOTION_BY_ID,
} from "../../../../services/ApiCalls";
import {
  activeInActiveArr,
  discountTypeArr,
} from "../../../../utilities/const";
import moment from "moment";
import Loader from "../../../../components/Common/Loader";
import fileUploader from "../../../../utilities/fileUploader";
import Loading from "../../../../components/Common/Loading";

const getSchema = (id) =>
  z.object({
    promotionName: z.string().min(1, { message: "Promotion name is required" }),
    link: z.string().min(1, { message: "Link is required" }),
    promotionImage: id
      ? z.string().optional()
      : z.string({ required_error: "Promotion image is required" }),

    status: z.boolean(),
    description: z
      .string()
      .min(1, { message: "Promotion description is required" }),
  });

const AddPromotion = () => {
  const [promoCodeDetails, setPromocodeDetails] = useState();
  const [imagePreview, setImagePreview] = useState(null);
  const { id } = useParams();

  const schema = useMemo(() => getSchema(id), [id]);
  const navigate = useNavigate();
  const [loader, setLoader] = useState();
  const [imgloader, setImgLoader] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    watch,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      status: "active",
    },
    values: {
      promotionName: promoCodeDetails?.promotionName || "",
      link: promoCodeDetails?.link || "",
      status: promoCodeDetails ? promoCodeDetails?.status === "active" : true,
      promotionImage: "",
      description: promoCodeDetails?.description || "",
    },
  });

  const handleImageChange = catchAsync(async (e) => {
    setImgLoader(true);
    const file = e.target.files[0];
    const res = await fileUploader(file);
    console.log(res, "checjggwyfewe");

    setValue("promotionImage", res?.link);
    setImgLoader(false);

    const reader = new FileReader();
    reader.onloadend = () => setImagePreview(reader.result);
    reader.readAsDataURL(file);
  });

  const submitHandler = catchAsync(async (data) => {
    setSubmitLoader(true);
    const body = {
      ...data,
      ...(id && { _id: id }),
      status: data.status ? "active" : "inactive",
    };

    const res = await (id ? UPDATE_PROMOTION(body) : ADD_PROMOTION(body));
    const success = checkResponse({
      res,
      showSuccess: true,
      setLoader: setSubmitLoader,
    });

    if (success) {
      navigate("/promotion");
    }
  }, setSubmitLoader);

  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await GET_PROMOTION_BY_ID(id);
    setImagePreview(res?.data?.data?.promotionImage);
    const success = checkResponse({
      res,
      setData: setPromocodeDetails,
      setLoader,
    });
  }, setLoader);

  useEffect(() => {
    if (id) getData();
  }, [id]);

  const handleCancel = () => {
    navigate("/promotion");
  };

  return (
    <>
      {loader && <Loader />}
      <section className="addPromo position-relative py-3">
        <Container>
          <Row className="justify-content-center">
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Link
                  to="/promotion"
                  className="border d-flex align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#1E232C"
                      stroke="#1E232C"
                      stroke-width="0.2"
                    />
                  </svg>
                </Link>
                <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                  {id ? "Edit Promotion" : "Add Promotion"}
                </h4>
              </div>
            </Col>
            <Col lg="6" className="my-2">
              <div
                className="formWrapper px-lg-5 p-md-4 p-3 rounded"
                style={{ border: "1px solid #dee2e6" }}
              >
                <Form onSubmit={handleSubmit(submitHandler)}>
                  <Row className="justify-content-between">
                    <Col lg="12" className="my-2">
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Promotion Name
                        </label>
                        <input
                          type="text"
                          placeholder="Enter Name"
                          className="form-control"
                          {...register("promotionName")}
                        />
                        {errors?.promotionName && (
                          <p className="text-danger m-0">
                            {errors?.promotionName?.message}
                          </p>
                        )}
                      </div>
                    </Col>
                    <Col lg="12" className="my-2">
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Description
                        </label>
                        <textarea
                          cols={40}
                          rows={5}
                          style={{ height: "unset" }}
                          placeholder="Enter Description"
                          className="form-control"
                          {...register("description")}
                        ></textarea>
                        {errors?.description && (
                          <p className="text-danger m-0">
                            {errors?.description?.message}
                          </p>
                        )}
                      </div>
                    </Col>

                    <Col lg="12" className="my-2">
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Link{" "}
                        </label>
                        <input
                          type="text"
                          placeholder="Enter Link"
                          className="form-control"
                          {...register("link")}
                        />
                        {errors?.link && (
                          <p className="text-danger m-0">
                            {errors?.link?.message}
                          </p>
                        )}
                      </div>
                    </Col>
                    <Col lg="12" className="my-2">
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Set Status of Promotion
                        </label>
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          {...register("status")}
                        />
                        {errors?.status && (
                          <p className="text-danger m-0">
                            {errors?.status?.message}
                          </p>
                        )}
                      </div>
                    </Col>

                    <Col lg="12" className="my-2">
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Promotion Image:
                        </label>
                        <input
                          type="file"
                          accept="image/*"
                          className="form-control"
                          onChange={handleImageChange}
                        />
                        {errors?.promotionImage && (
                          <p className="text-danger m-0">
                            {errors?.promotionImage?.message}
                          </p>
                        )}
                        {imgloader ? (
                          <div
                            style={{ height: 140, width: 140 }}
                            className="img-fluid rounded-circle object-fit-cover"
                          >
                            <Loading fullSize={true} />
                          </div>
                        ) : (
                          <>
                            {imagePreview && (
                              <img
                                src={imagePreview}
                                alt="Promotion Preview"
                                style={{ width: "100%", marginTop: "10px" }}
                              />
                            )}
                          </>
                        )}
                      </div>
                    </Col>

                    <Col lg="12" className="my-2">
                      <div className="d-flex align-items-center justify-content-center gap-10">
                        <Button
                          disabled={submitLoader}
                          type="button"
                          onClick={handleCancel}
                          className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                        >
                          Cancel
                        </Button>
                        <Button
                          disabled={submitLoader}
                          type="submit"
                          className="d-flex align-items-center justify-content-center commonBtn"
                        >
                          Submit
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddPromotion;
